
    const data = {"name":"src/core/icons/microsoft-azure","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13.05 4.24 6.56 18.05 2 18l5.09-8.76 5.96-5m.7 1.09L22 19.76H6.74l9.3-1.66-4.87-5.79 2.58-6.98Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            